function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M17.6 6.212l6.299 6.32a.6.6 0 0 1 0 .955l-6.307 6.307a.601.601 0 0 1-.85-.85l5.343-5.346H7.208a.6.6 0 0 1 0-1.202h14.877L16.75 7.062a.6.6 0 1 1 .85-.85zm-6.487 18.799h-8.11A3.004 3.004 0 0 1 0 22.007V3.987A3.004 3.004 0 0 1 3.003.982h8.11a3.003 3.003 0 0 1 3.003 3.003V7.35a.6.6 0 0 1-1.201 0V3.986c0-.995-.807-1.802-1.802-1.802h-8.11c-.995 0-1.802.807-1.802 1.802v18.021c0 .995.807 1.802 1.802 1.802h8.11c.995 0 1.802-.807 1.802-1.802V18.69a.6.6 0 0 1 1.201 0v3.318a3.004 3.004 0 0 1-3.003 3.004z"
}));

const SvgIcLogout = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-logout.761a53a3.svg";
export { ForwardRef as ReactComponent };